import {Box} from '@mui/material';
import {FC} from 'react';

export const PageElement: FC = ({children}) => {
    return <Box sx={{my: 10}}>{children}</Box>;
};
